var _style, _path, _line, _line2, _line3, _line4, _defs, _g, _defs2, _g2, _defs3, _g3, _defs4, _g4, _defs5, _g5, _defs6, _g6, _defs7, _g7, _defs8, _g8, _g9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMfa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120.2 118.8",
    style: {
      enableBackground: "new 0 0 120.2 118.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#869095;stroke-width:2;stroke-linejoin:round;}\n\t.st1{clip-path:url(#SVGID_2_);}\n\t.st2{fill:#869095;}\n\t.st3{clip-path:url(#SVGID_4_);}\n\t.st4{clip-path:url(#SVGID_6_);}\n\t.st5{clip-path:url(#SVGID_8_);}\n\t.st6{clip-path:url(#SVGID_10_);}\n\t.st7{clip-path:url(#SVGID_12_);}\n\t.st8{clip-path:url(#SVGID_14_);}\n\t.st9{clip-path:url(#SVGID_16_);}\n\t.st10{fill:none;}\n\t.st11{fill:none;stroke:#879196;stroke-width:2;stroke-miterlimit:10;}\n\t.st12{fill:#FFFFFF;stroke:#879196;stroke-width:2;stroke-miterlimit:10;}\n\t.st13{fill:#879196;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 28") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TEXT"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FILE_NAMES"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46,69.8V28.1c0-3.7,3.1-6.7,6.8-6.7c0,0,0,0,0,0h27.4c3.7,0,6.8,3,6.8,6.7c0,0,0,0,0,0v66.1 c0,2.9-2.4,5.2-5.2,5.2c0,0,0,0,0,0H51.2c-2.9,0-5.2-2.3-5.2-5.2c0,0,0,0,0,0V28.1c0-3.7,3.1-6.7,6.8-6.7c0,0,0,0,0,0h27.4 c3.7,0,6.8,3,6.8,6.7c0,0,0,0,0,0"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 74,
    y1: 26.4,
    x2: 64,
    y2: 26.4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 62,
    y1: 26.4,
    x2: 59,
    y2: 26.4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 87,
    y1: 90.4,
    x2: 46,
    y2: 90.4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 46,
    y1: 31.4,
    x2: 87,
    y2: 31.4
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 65.3,
    y: 54.9,
    width: 11.4,
    height: 10.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.3,
    y: 42.3,
    className: "st2",
    width: 75.3,
    height: 36
  })))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: 89.4,
    y: 60.4,
    width: 9.3,
    height: 1.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.1,
    y: 58.3,
    className: "st2",
    width: 61.9,
    height: 6
  })))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: 93.1,
    y: 56.7,
    width: 5.7,
    height: 1.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.1,
    y: 54.6,
    className: "st2",
    width: 37.7,
    height: 6
  })))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    x: 78.8,
    y: 70.6,
    width: 5.7,
    height: 7.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.8,
    y: 61.9,
    className: "st2",
    width: 37.7,
    height: 24.9
  })))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_9_",
    x: 78.8,
    y: 55.8,
    width: 4.7,
    height: 6.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.6,
    y: 48.4,
    className: "st2",
    width: 31,
    height: 21.2
  })))), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_11_",
    x: 90.5,
    y: 71.1,
    width: 8.5,
    height: 6.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible"
    }
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66.5,
    y: 52.9,
    className: "st2",
    width: 56.3,
    height: 42.8
  })))), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_13_",
    x: 78.8,
    y: 44.4,
    width: 8.2,
    height: 9.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 55.9,
    y: 37.5,
    className: "st2",
    width: 54,
    height: 23.3
  })))), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_15_",
    x: 78.8,
    y: 63.6,
    width: 20.2,
    height: 5.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible"
    }
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.1,
    y: 47.7,
    className: "st2",
    width: 133.6,
    height: 37.3
  })))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "ILLUSTRATION"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    className: "st10",
    width: 120,
    height: 118.8
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st11",
    points: "62,41.9 56.9,41.9 56.9,46.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st11",
    points: "62,70.6 56.9,70.6 56.9,65.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.1,
    y: 43,
    className: "st12",
    width: 9.7,
    height: 9.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 45.6,
    className: "st13",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.1,
    y: 68.1,
    className: "st12",
    width: 9.7,
    height: 9.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 70.6,
    className: "st13",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.3,
    y: 44.6,
    className: "st12",
    width: 9.7,
    height: 9.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.1,
    y: 47.2,
    className: "st13",
    width: 4,
    height: 4
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMfa);
export default __webpack_public_path__ + "static/media/mfa.a5fff87d.svg";
export { ForwardRef as ReactComponent };